import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  horizontal: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '100%',
    flexDirection: 'row',
  },

  vertical: {
    paddingTop: 40,
    paddingBottom: 80,
    alignSelf: 'center',
    width: 700,
  },

  left: {
    padding: '2%',
    width: '50%',
    backgroundColor: '#f5f8f9',
  },

  right: {
    padding: '2%',
    width: '50%',
  },

  text: {
    float: 'left',
    color: '#32363A',
    fontFamily: 'PingFangSC-Regular',
    lineHeight: '24px',
  },
});



// WEBPACK FOOTER //
// ./src/components/questions/blank/styles.js